import { createStandardAction } from 'typesafe-actions'

export type RequestStatus = 'loading' | 'success' | number

export const networkStatusFor = (source: string) =>
  createStandardAction('set/networkstatus/' + source)<RequestStatus>()
